import { useMemo } from 'react'
import { Notification, KIND } from 'baseui/notification';
import { AlarmDetailsDto, getBehavior, isAcknowledged, useAckAlarmByIdMutation } from '../../services/alarm'
import { Block } from 'baseui/block';
import { useObjectAlarms } from '../../hooks/useObjectAlarms'
import { useIntl, FormattedMessage } from 'react-intl';
import { getAlarmClassStyle } from './alarmClassStyles';
import { useStyletron } from 'baseui';
import { COLOR, NotificationCircle } from 'baseui/badge';
import { useIntlAlarmMessage } from '../../hooks/useIntlAlarmMessage';
import { LabelSmall, ParagraphXSmall } from 'baseui/typography';
import { IoCalendarOutline } from 'react-icons/io5';
import { useTimeAgoFormatter } from '../../hooks/useTimeAgoFormatter';
import TimeAgo from 'react-timeago'
import { VscCheck, VscCheckAll } from 'react-icons/vsc';
import { Button } from 'baseui/button';

export interface ObjectAlarmsProps {
  id: string;
  resourceGroupId: string;
  includeAlarmsFromChildren?: boolean
}

export const ObjectAlarms = (props: ObjectAlarmsProps) => {

  const { items: alarms, error, isLoading } = useObjectAlarms(props.id, props.resourceGroupId,props.includeAlarmsFromChildren ?? false)
  const first = useMemo(() => alarms?.slice()[0], [alarms]);

  return (
    !!first ?
      (<AlarmNotification alarmCnt={alarms?.length ?? 0} alarm={first}></AlarmNotification>)
      :
      (<></>)
  )
}

const AlarmNotification = (props: { alarm: AlarmDetailsDto, alarmCnt: number }) => {
  const { alarm, alarmCnt } = props;
  const intl = useIntl();
  const [css, theme] = useStyletron();
  const alarmMessage = useIntlAlarmMessage(alarm);
  const style1 = getAlarmClassStyle(alarm.alarmClass.name || '', alarm.offTime !== undefined && alarm.offTime !== null, theme);
  const { formatter } = useTimeAgoFormatter();
  const needAck = !isAcknowledged(alarm)
  const [ack, { data, isLoading, error }] = useAckAlarmByIdMutation()

  return (
    <NotificationCircle hidden={alarmCnt <= 1}
      placement={'topRight'}
      horizontalOffset="10px"
      verticalOffset="5px"
      color={COLOR.primary}
      content={alarmCnt} >

      <Notification kind={KIND.negative} overrides={{
        Body: {
          style: ({ $theme }: any) => ({
            alignSelf: 'stretch',
            width: 'auto',
            backgroundColor: style1?.backgroundColor,
            color: style1?.color,
            border: `${style1?.color} 1px solid`,
            padding: '5px 15px 5px 15px',
          })
        },
        InnerContainer: {
          style: ({ $theme }) => ({
            width: '95%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            alignItems: 'baseline'
          })
        }
      }}>

        <Block display={'flex'} alignItems={'baseline'} justifyContent={'flex-start'} gridGap={theme.sizing.scale300}>

          <span className={css({ textOverflow: 'ellipsis', overflow: 'hidden' })}>{alarmMessage}</span>
        </Block>
        {!alarm.offTime ?
          <ParagraphXSmall margin={0} >  <span><IoCalendarOutline></IoCalendarOutline> <TimeAgo date={alarm.onTime} formatter={formatter} /></span></ParagraphXSmall>
          :
          <>
            <ParagraphXSmall margin={0}><b><FormattedMessage id='alarms.gone' defaultMessage='gone' /></b><span> <IoCalendarOutline></IoCalendarOutline> <TimeAgo date={alarm.onTime} formatter={formatter} /></span></ParagraphXSmall>
          </>
        }

      </Notification>
    </NotificationCircle>

  )
}

